import angular from "angular";

function datePicker () {

  return {
    restrict: 'A',
    link: (scope, element, attrs) => {
      let date = new Date();
      let year = date.getFullYear();
      let options = {changeMonth: true,changeYear: true,showButtonPanel: true};

      if($(element).hasClass('birthday')){
        let minMonth = date.getMonth() < 10 ? '0'+date.getMonth() : date.getMonth();
        let minDate = date.getDate() < 10 ? '0'+date.getDate() : date.getDate();
        options.defaultDate = new Date(year-18, minMonth, minDate);
        options.yearRange = '-100:-18';
      }

      $(element).datepicker(options);
      $(element).datepicker("option", "dateFormat", "yy-mm-dd");
    },
  }
}

export default angular.module('directives.datePicker', []).directive('datePicker', datePicker).name;



// WEBPACK FOOTER //
// ./src/app/directives/datePicker.js